import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteRelatedContentUrlComponent } from './website-related-content-url.component'
import { SharedModule } from '../shared/shared.module'
import { PipesModule } from '../../pipes/pipes.module'
import { RouterModule } from '@angular/router'


@NgModule({
  imports: [CommonModule, SharedModule, PipesModule, RouterModule],
  declarations: [WebsiteRelatedContentUrlComponent],
  exports: [WebsiteRelatedContentUrlComponent],
  providers: [],
})
export class WebsiteRelatedContentUrlModule {
}
